// CONCATENATED MODULE: ./node_modules/@shopify/theme-addresses/theme-addresses.js
/**
 * CountryProvinceSelector Constructor
 * @param {String} countryOptions the country options in html string
 */
function CountryProvinceSelector(countryOptions) {
  if (typeof countryOptions !== "string") {
    throw new TypeError(countryOptions + " is not a string.");
  }
  this.countryOptions = countryOptions;
}

/**
 * Builds the country and province selector with the given node element
 * @param {Node} countryNodeElement The <select> element for country
 * @param {Node} provinceNodeElement The <select> element for province
 * @param {Object} options Additional settings available
 * @param {CountryProvinceSelector~onCountryChange} options.onCountryChange callback after a country `change` event
 * @param {CountryProvinceSelector~onProvinceChange} options.onProvinceChange callback after a province `change` event
 */
CountryProvinceSelector.prototype.build = function (
  countryNodeElement,
  provinceNodeElement,
  options
) {
  if (typeof countryNodeElement !== "object") {
    throw new TypeError(countryNodeElement + " is not a object.");
  }

  if (typeof provinceNodeElement !== "object") {
    throw new TypeError(provinceNodeElement + " is not a object.");
  }

  var defaultValue = countryNodeElement.getAttribute("data-default");
  options = options || {};

  countryNodeElement.innerHTML = this.countryOptions;
  countryNodeElement.value = defaultValue;

  if (defaultValue && getOption(countryNodeElement, defaultValue)) {
    var provinces = buildProvince(countryNodeElement, provinceNodeElement, defaultValue);
    options.onCountryChange &&
      options.onCountryChange(provinces, provinceNodeElement, countryNodeElement);
  }

  // Listen for value change on the country select
  countryNodeElement.addEventListener("change", function (event) {
    var target = event.target;
    var selectedValue = target.value;

    var provinces = buildProvince(target, provinceNodeElement, selectedValue);
    options.onCountryChange &&
      options.onCountryChange(provinces, provinceNodeElement, countryNodeElement);
  });

  options.onProvinceChange &&
    provinceNodeElement.addEventListener("change", options.onProvinceChange);
};

/**
 * This callback is called after a user interacted with a country `<select>`
 * @callback CountryProvinceSelector~onCountryChange
 * @param {array} provinces the parsed provinces
 * @param {Node} provinceNodeElement province `<select>` element
 * @param {Node} countryNodeElement country `<select>` element
 */

/**
 * This callback is called after a user interacted with a province `<select>`
 * @callback CountryProvinceSelector~onProvinceChange
 * @param {Event} event the province selector `change` event object
 */

/**
 * Returns the <option> with the specified value from the
 * given node element
 * A null is returned if no such <option> is found
 */
function getOption(nodeElement, value) {
  return nodeElement.querySelector('option[value="' + value + '"]');
}

/**
 * Builds the options for province selector
 */
function buildOptions(provinceNodeElement, provinces) {
  var defaultValue = provinceNodeElement.getAttribute("data-default");

  provinces.forEach(function (option) {
    var optionElement = document.createElement("option");
    optionElement.value = option[0];
    optionElement.textContent = option[1];

    provinceNodeElement.appendChild(optionElement);
  });

  if (defaultValue && getOption(provinceNodeElement, defaultValue)) {
    provinceNodeElement.value = defaultValue;
  }
}

/**
 * Builds the province selector
 */
function buildProvince(countryNodeElement, provinceNodeElement, selectedValue) {
  var selectedOption = getOption(countryNodeElement, selectedValue);
  var provinces = JSON.parse(selectedOption.getAttribute("data-provinces"));

  provinceNodeElement.options.length = 0;

  if (provinces.length) {
    buildOptions(provinceNodeElement, provinces);
  }

  return provinces;
}

class ShippingCalculator {
  constructor(el) {
    this.el = el;
    this.shippingContainer = this.el.querySelector("[data-cartshipping]");

    this.shippingToggle = this.el.querySelector("[data-cartshipping-toggle]");
    this.shippingResponse = this.shippingContainer.querySelector("[data-cartshipping-response]");
    this.shippingResponseMessage = this.shippingResponse.querySelector(
      "[data-cartshipping-message]"
    );
    this.shippingResponseRates = this.shippingResponse.querySelector("[data-cartshipping-rates]");
    this.shippingSubmit = this.shippingContainer.querySelector("[data-cartshipping-submit]");

    // Extract shipping messages and settings from data attributes
    this.shipping = {
      one_rate:
        this.shippingContainer.getAttribute("data-one-rate") || "Shipping to *address*: *rate*",
      multiple_rates:
        this.shippingContainer.getAttribute("data-multiple-rates") ||
        "Shipping to *address*: *number_of_rates* rates starting at *rate*",
      no_rates:
        this.shippingContainer.getAttribute("data-no-rates") ||
        "No shipping rates available for *address*",
      rate_value: this.shippingContainer.getAttribute("data-rate-value") || "*rate_title*: *rate*",
      calculate_shipping:
        this.shippingContainer.getAttribute("data-calculate-shipping") || "Calculate shipping",
      calculating: this.shippingContainer.getAttribute("data-calculating") || "Calculating...",
    };

    this.settings = {
      money_format: this.shippingContainer.getAttribute("data-money-format") || "${{amount}}",
    };

    this._initShippingCalc();
  }

  _initShippingCalc() {
    this._bindShippingCalcEvents();

    const countrySelect = document.getElementById("address_country");
    const provinceSelect = document.getElementById("address_province");
    const provinceContainer = document.getElementById("address_province_container");

    this.shippingCountryProvinceSelector = new CountryProvinceSelector(countrySelect.innerHTML);
    this.shippingCountryProvinceSelector.build(countrySelect, provinceSelect, {
      onCountryChange: (provinces) => {
        if (provinces.length) {
          provinceContainer.style.display = "flex";
        } else {
          provinceContainer.style.display = "none";
        }

        // Update labels if window.Countries is available
        if (window.Countries && window.Countries[countrySelect.value]) {
          const { label, zip_label: zipLabel } = window.Countries[countrySelect.value];
          const provinceLabel = provinceContainer.querySelector('label[for="address_province"]');
          const zipLabel_elem = this.el.querySelector('label[for="address_zip"]');

          if (provinceLabel) {
            provinceLabel.innerHTML = label;
          }
          if (zipLabel_elem) {
            zipLabel_elem.innerHTML = zipLabel;
          }
        }
      },
    });
  }

  _bindShippingCalcEvents() {
    // Toggle button click handler
    const toggleButton = this.el.querySelector("[data-cartshipping-toggle]");
    const shippingElement = document.querySelector("[data-shipping-cost]");

    if (toggleButton) {
      toggleButton.addEventListener("click", () => {
        this._toggleShippingCalc();
      });
    }

    if (shippingElement) {
      shippingElement.addEventListener("click", () => {
        this._toggleShippingCalc();
      });
    }

    // Submit button click handler
    const submitButton = this.el.querySelector("[data-cartshipping-submit]");
    if (submitButton) {
      submitButton.addEventListener("click", () => {
        this._getShippingRates();
      });
    }

    // Enter key handler for zip code input
    const zipInput = document.getElementById("address_zip");
    if (zipInput) {
      zipInput.addEventListener("keypress", (event) => {
        if (event.key === "Enter") {
          event.preventDefault();
          if (submitButton) {
            submitButton.click();
          }
        }
      });
    }
  }

  _toggleShippingCalc() {
    const shippingToggle = this.el.querySelector("[data-cartshipping-toggle]");
    const shipping = this.el.querySelector("[data-cartshipping]");

    if (shippingToggle && shipping) {
      const oldText = shippingToggle.textContent;
      const newText = shippingToggle.getAttribute("data-cartshipping-toggle");

      shippingToggle.textContent = newText;
      shippingToggle.setAttribute("data-cartshipping-toggle", oldText);

      shipping.classList.toggle("open");
    }
  }

  _getShippingRates() {
    this._disableShippingButton();

    const shippingAddress = {};
    shippingAddress.country = document.getElementById("address_country").value || "";
    shippingAddress.province = document.getElementById("address_province").value || "";
    shippingAddress.zip = document.getElementById("address_zip").value || "";

    const currencySymbol = document
      .querySelector(".delivery-calculate")
      .getAttribute("data-currency-symbol");

    const queryString = Object.keys(shippingAddress)
      .map(
        (key) =>
          `${encodeURIComponent(`shipping_address[${key}]`)}=${encodeURIComponent(
            shippingAddress[key]
          )}`
      )
      .join("&");

    fetch(`${window.routes.cart_url}/shipping_rates.json?${queryString}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        const rates = data.shipping_rates;
        const addressBase = [];

        if (shippingAddress.zip.length) {
          addressBase.push(shippingAddress.zip.trim());
        }

        if (shippingAddress.province.length) {
          addressBase.push(shippingAddress.province);
        }

        if (shippingAddress.country.length) {
          addressBase.push(shippingAddress.country);
        }

        const address = addressBase.join(", ");
        let message = "";

        if (rates.length > 1) {
          const firstRate = this.rates[0].price;

          message = this.shipping.multiple_rates
            .replace("{{ address }}", address)
            .replace("{{ number_of_rates }}", rates.length)
            .replace("{{ rate }}", `<span>${currencySymbol}${firstRate}</span>`);
        } else if (rates.length === 1) {
          message = this.shipping.one_rate.replace("{{ address }}", address);
        } else {
          message = this.shipping.no_rates;
        }

        const ratesList = rates.map((rate) => {
          const price = rate.price;
          console.log("rate:", rate.price);
          const rateValue = this.shipping.rate_value
            .replace("{{ rate_title }}", rate.name)
            .replace("{{ rate }}", `<span>${currencySymbol}${price}</span>`);
          return `<li>${rateValue}</li>`;
        });

        this._handleShippingResponse({
          message,
          rates: ratesList,
        });
      })
      .catch((err) => {
        this._handleErrors(err.responseJSON || {});
        console.log(err);
      });
  }

  _enableShippingButton() {
    this.shippingSubmit.innerHTML = this.shipping.calculate_shipping;
    this.shippingSubmit.disabled = false;
  }

  _disableShippingButton() {
    this.shippingSubmit.innerHTML = this.shipping.calculating;
    this.shippingSubmit.disabled = true;
  }

  _showShippingResponse() {
    this.shippingResponse.classList.add("visible");
  }

  _hideShippingResponse() {
    this.shippingResponse.classList.remove("visible");
  }

  _handleErrors(errors) {
    // Handle error response from shipping rates API
    const errorMessage = errors.message || "An error occurred while calculating shipping rates.";
    this._handleShippingResponse({
      message: errorMessage,
      rates: null,
    });
  }

  /**
   * Handle shipping responses
   *
   * @param {object} shippingResponse
   * @property {String} shippingResponse.messages - Error / Success message
   * @property {Array|String} shippingResponse.rates - Shipping rates
   * @private
   */

  _handleShippingResponse() {
    let shippingResponse = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    // Hide the response so that it can be populated smoothly
    this._hideShippingResponse();

    const message = shippingResponse.message || null;
    const rates = shippingResponse.rates || null; // Empty out contents

    this.shippingResponseMessage.innerHTML = "";
    this.shippingResponseRates.innerHTML = "";

    if (message) {
      this.shippingResponseMessage.innerHTML = message;
    }

    if (rates) {
      this.shippingResponseRates.innerHTML = rates.join("");
    } // Reset the calculating button so it can be used again

    this._enableShippingButton(); // No error provided

    if (!message && !rates) {
      return;
    } // Show the response

    this._showShippingResponse();
  }
}

// Initialize the shipping calculator when the DOM is ready
document.addEventListener("DOMContentLoaded", function () {
  const cartShippingContainer = document.querySelector(".cart-shipping");

  if (cartShippingContainer) {
    console.log("Initializing ShippingCalculator");
    new ShippingCalculator(cartShippingContainer);
  }
});
